import { PaymentFees } from 'src/store/payments/types';

export type BankAccountFeeReference = Pick<
  PaymentFees,
  | 'achPercentage'
  | 'achFixed'
  | 'achThreshold'
  | 'achThresholdExceededPercentage'
>;

export type BankAccountFeeDetails = {
  feeLabel: string;
  total: number;
};

// Matches stripe_charge.go / invoice_operation.go: ACHFixed 0 means the
// percentage applies with no dollar cap. A zero cap is not a zero fee.
export function calculateBankAccountProcessingFee(
  amountDue: number,
  feeReference: BankAccountFeeReference,
  absorbACHFee: boolean,
  currencyPrefix = '$',
): BankAccountFeeDetails {
  const achPercentageFee = (amountDue * feeReference.achPercentage) / 100;
  const achFeeFixedAmount = feeReference.achFixed * 100;
  let feeLabel = `${feeReference.achPercentage}%`;

  if (achPercentageFee >= achFeeFixedAmount && achFeeFixedAmount > 0) {
    feeLabel = `${currencyPrefix}${feeReference.achFixed}`;
  }

  let achThresholdExceedFee = 0;
  const achThreshold = feeReference.achThreshold * 100;
  if (
    achThreshold > 0 &&
    feeReference.achThresholdExceededPercentage &&
    amountDue > achThreshold
  ) {
    feeLabel = `${feeLabel} + ${feeReference.achThresholdExceededPercentage}%`;
    achThresholdExceedFee =
      (amountDue * feeReference.achThresholdExceededPercentage) / 100;
  }

  if (absorbACHFee) {
    return { feeLabel, total: 0 };
  }

  const cappedACHFee =
    achFeeFixedAmount > 0
      ? Math.min(achPercentageFee, achFeeFixedAmount)
      : achPercentageFee;

  return {
    feeLabel,
    total: cappedACHFee + achThresholdExceedFee,
  };
}
